import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import classNames from 'classnames';
import styles from './ContentEditable.module.scss';
export const EMPTY_TEXT_CODE = '\u200B';
const ContentEditable = forwardRef(({ id, value, contentEditable, placeholder = '', className, onBlur }, outerRef) => {
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current && ref.current.textContent !== value) {
            ref.current.textContent = value
                ? value.replace(EMPTY_TEXT_CODE, '') + EMPTY_TEXT_CODE
                : EMPTY_TEXT_CODE;
        }
        else if (ref.current && !value) {
            ref.current.textContent = EMPTY_TEXT_CODE;
        }
    }, [value]);
    useImperativeHandle(outerRef, () => ({
        focus: () => ref.current.focus(),
    }));
    return (_jsx("span", { ref: ref, id: id, "placeholder-after-content": placeholder, contentEditable: contentEditable, suppressContentEditableWarning: true, className: classNames(styles.container, className), onBlur: (event) => {
            event.currentTarget.classList.remove(styles.containerFocused);
            if (typeof onBlur === 'function') {
                onBlur(event);
            }
        }, onFocus: (event) => {
            event.currentTarget.classList.add(styles.containerFocused);
            const selection = window.getSelection();
            if (!selection.rangeCount)
                return null;
            const range = selection.getRangeAt(0);
            const offset = range.startOffset;
            const emptyTextCodeIndex = event.currentTarget.textContent.indexOf(EMPTY_TEXT_CODE);
            if (offset > emptyTextCodeIndex) {
                try {
                    range.setStart(ref.current.firstChild, emptyTextCodeIndex);
                    range.collapse(true);
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
                catch (e) {
                    // console.error('Error setting caret position:', e)
                }
            }
        } }));
});
export default ContentEditable;
